import React from "react"
import {useTranslation} from "react-i18next";

import {useCreateStation} from "../query";
import MDLoadingButton from "../../../components/MDLoadingButton";
import LocationSection from "../stationForm/LocationSection";
import IdentificationSection from "../stationForm/IdentificationSection";
import MeasurementTypesSection from "../stationForm/MeasurementTypesSection";
import ActivityPeriodSection from "../stationForm/ActivityPeriodSection";
import NotesSection from "../stationForm/NotesSection";

import MDTypography from "materialDashboard/components/MDTypography";
import MDBox from "materialDashboard/components/MDBox";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import useStationForm from "../stationForm/useStationForm";


const StationCreate = () => {
    const {t} = useTranslation(['stations', 'validation', 'enums']);
    const createStation = useCreateStation();

    const handleSubmit = async (data) => {
        await createStation.mutateAsync(data);
    }

    const {formik, handlePositionChange} = useStationForm({onSubmit: handleSubmit});

    // Disable submit when the stationForm has been submitted and it is invalid
    const submitDisabled = formik.isSubmitting || (formik.submitCount > 0 && !formik.isValid);

    return <Container maxWidth="xl">
        <Card sx={{mt:4}}>
            <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
            >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                    {t('stationCreate.title')}
                </MDTypography>
            </MDBox>

            <Grid container sx={{p: 3}} columnSpacing={6} rowSpacing={6}>

                <Grid item xs={12} lg={5}>
                    <Grid container rowSpacing={6}>
                        <Grid item xs={12}>
                            <IdentificationSection formik={formik}/>
                        </Grid>

                        <Grid item xs={12}>
                            <MeasurementTypesSection formik={formik}/>
                        </Grid>
                        <Grid item xs={12}>
                            <ActivityPeriodSection formik={formik} station={null}/>
                        </Grid>
                        <Grid item xs={12}>
                            <NotesSection formik={formik}/>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} lg={7}>
                    <Grid container rowSpacing={6}>
                        <Grid item xs={12}>
                            <LocationSection formik={formik} onPositionChange={handlePositionChange}/>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} lg={12} sx={{display: "flex", justifyContent: "flex-end"}}>
                    <MDLoadingButton variant="gradient" color="info" onClick={formik.handleSubmit} sx={{ml: "auto"}}
                                     disabled={submitDisabled}
                                     loading={formik.isSubmitting}>
                        {t('stationCreate.submit')}
                    </MDLoadingButton>
                </Grid>
            </Grid>
        </Card>
    </Container>
}

export default StationCreate;